var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 1.783 1.537",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil0 {fill:#000000;fill-rule:nonzero}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M0.261 1.537c-0.09,0 -0.173,-0.049 -0.22,-0.126 -0.053,-0.087 -0.053,-0.191 -0.009,-0.282l0.583 -0.954c0.066,-0.097 0.152,-0.175 0.277,-0.175 0.125,0 0.211,0.078 0.277,0.175l0.58 0.949c0.048,0.089 0.046,0.201 -0.007,0.287 -0.047,0.077 -0.129,0.126 -0.22,0.126l-1.261 0zm0.631 -0.498c0.053,0 0.095,0.043 0.095,0.096 0,0.053 -0.042,0.095 -0.095,0.095 -0.053,0 -0.096,-0.042 -0.096,-0.095 0,-0.053 0.043,-0.096 0.096,-0.096zm0 -0.095c-0.035,0 -0.06,-0.029 -0.064,-0.064l-0.032 -0.287c-0.005,-0.049 0.047,-0.095 0.096,-0.095 0.049,0 0.101,0.046 0.095,0.095l-0.032 0.287c-0.003,0.034 -0.027,0.064 -0.063,0.064zm-0.631 0.466l1.261 0c0.047,0 0.087,-0.026 0.112,-0.066 0.029,-0.048 0.028,-0.106 0.005,-0.156l-0.576 -0.942c-0.041,-0.06 -0.092,-0.119 -0.171,-0.119 -0.079,0 -0.131,0.059 -0.172,0.119l-0.575 0.942c-0.024,0.051 -0.025,0.108 0.005,0.156 0.024,0.04 0.064,0.066 0.111,0.066z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d6e4fcf42d95355dd80ebf37156f61e7.svg";
export { ForwardRef as ReactComponent };